import {Injectable} from '@angular/core';
import {EffectUtil, SimpleRedirectEffectType} from '../effect-util';
import {aktualizujZbiorUszkodzenPrzedmiotow, usunZbiorUszkodzenPrzedmiotow} from './zbiorUszkodzenPrzedmiotu.actions';

@Injectable()
export class ZbiorUszkodzenPrzedmiotowEffects {

  constructor(private effectUtil: EffectUtil) {
  }

  kliknietoAktualizujZbiorUszkodzenRedirect$: SimpleRedirectEffectType<any> = this.effectUtil.createRedirectEffect(aktualizujZbiorUszkodzenPrzedmiotow, '../procesUszkodzen');
}
